import {
    ArticlesState,
    PageState,
    initialArticlesState,
    initialPageState,
    slugAndQueryKey,
} from "@/mk2/apps/faq/containers/FaqIndex/FaqIndex.reducers";
import { AppState } from "@/mk2/reducers";

export const getFaqIndexPageState = (state: AppState): PageState =>
    state.containers.faq.faqIndex || initialPageState;

export const getFaqIndexArticlesState = (
    state: AppState,
    articleSlug: string,
    query: string,
): ArticlesState =>
    getFaqIndexPageState(state).articles[slugAndQueryKey(articleSlug, query)] ||
    initialArticlesState;
